import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import HeadSub from '../../../../components/comm/HeadSub';
import style from './MyHospitalSetting.module.css';
import { useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import Modal from "../../../../components/comm/Modal"


const MyHospitalSetting = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

    const [urlRootChage, setUrlRootchage] = useState(null);

    
    //모달창
    const [isOpen, setIsOpen] = useState(false);

     useEffect(() => {
        if (location.state?.showModal) {
            setIsOpen(true);

            // showModal만 제거
            navigate(location.pathname, { 
                replace: true, 
                state: { hsptlNm: location.state.hsptlNm } 
            });
        }
    }, [location.state, navigate]);

    useEffect(() => {
        const urlRoot = sessionStorage.getItem('UrlRoot');

        setUrlRootchage(urlRoot);
        
    }, [])


    //뒤로 가기 
   const handleBack = () => {
        if (urlRootChage) {
            navigate(URL.HOSPITAL_HOME, { replace: true });
            sessionStorage.removeItem("UrlRoot");    
        } else {
            navigate(-1);
        }
    };
    
    return (
        <>
            {/* <HeadSub title="내 병원 설정" onBack={()=>{navigate(URL.APP_SETTINGS)}}/> */}
            <HeadSub title="내 병원 설정" onBack={handleBack}/>

            <div id="sub-content">
                <div className='inner-wrap' data-pad="normal">

                    {
                        loginUser.usrHsptlMap.length > 0 ? 
                            <div className={style['content-box']}>
                                {/* 연결된 병원이 있을시 */}
                                <div className={style['top-box']}> 
                                    <p>연결된 병원</p>
                                    <div className={style['btns-box']}>
                                        <button className={style['link-btn']} onClick={()=> navigate(URL.HOSPITAL_ORDER_SETTING)}>
                                            <span>병원 순서 변경</span>
                                        </button>
                                    </div>
                                </div>           

                                <div className={style['lists-box']}>
                                    <ul>
                                        {
                                            loginUser.usrHsptlMap.map((item, index) => {
                                                return (
                                                     <li key={`${item.cnncHsptlNm}-${index}`}>
                                                        <div className={style['tit-box']}>
                                                            <p className={style['title']}>{item.cnncHsptlNm}</p>
                                                            {
                                                                item.hsptlSortOrdr === 1 && <span className={style['main-mark']}>대표 병원</span>
                                                            }
                                                            
                                                        </div>
                                                        <span>내 환자 번호 {item.cnncPatntNo}</span>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                                
                                <div className={style['bot-btn-box']}>
                                    {loginUser.usrHsptlMap.length !== 7 && ( // 병원이 전체 7개일때 숨김 
                                        <button className='btn' data-btn-size='md' data-btn-type="fill-main" data-btn-width='full' onClick={()=> navigate(URL.MY_HOSPITAL_CONNECTION)}>
                                            <span>새로운 병원 연결</span>
                                        </button>
                                    )}
                                    <button className={style['disconnect-btn']} onClick={()=> navigate(URL.MY_HOSPITAL_DISCONNECT)}>
                                        <span>기존 병원 연결 해제</span>
                                    </button>
                                </div>

                            </div>

                            : 
                            <div className={style['content-box']}>
                                {/* 연결된 병원이 없을시 */}
                                <div className={style['top-box']}> 
                                    <p>연결된 병원</p>
                                </div>           

                                <div className={style['mid-box']}> 
                                    <div className={style['empty-box']}>
                                        <p>연결된 병원이 없습니다.</p>        
                                        <span>지금 바로 내 병원을 설정하고 <br />
                                        케어플러스의 다양한 서비스를 이용해보세요!</span>
                                        <div className='btn-box'>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size="smd" data-btn-icon='arrow' onClick={()=> navigate(URL.MY_HOSPITAL_CONNECTION)}>
                                            <span> 병원 연결 바로가기 </span>  
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }

                </div>
            </div>


            <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> {location.state?.hsptlNm}을 <br/> 대표 병원으로 설정하였습니다</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout' data-type='b'>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={()=> setIsOpen(false)}>
                                <span>확인</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal> 
            
        </>
    );
};

export default MyHospitalSetting;
